import React from 'react';
import {VisibilityOff} from '@material-ui/icons';

export const VisibilityOffIcon = () => {
  return <VisibilityOff />;
};
